import React from "react";

const Kotlin_If_Else = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Kotlin If...Else</h1>
      <p>Content for Kotlin If...Else goes here.</p>
    </div>
  );
};

export default Kotlin_If_Else;
